var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#d9d9d9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4064_2403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1922 10.2153C11.5157 10.2153 12.6618 9.75958 13.5983 8.86047C14.5347 7.9615 15.0094 6.86155 15.0094 5.5908C15.0094 4.3205 14.5347 3.2204 13.5981 2.32114C12.6615 1.42231 11.5156 0.966602 10.1922 0.966602C8.8685 0.966602 7.72272 1.42231 6.78629 2.32128C5.84985 3.22026 5.375 4.32035 5.375 5.5908C5.375 6.86155 5.84985 7.96164 6.78644 8.86061C7.72302 9.75944 8.86896 10.2153 10.1922 10.2153Z",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6222 15.7304C18.5952 15.3563 18.5406 14.9482 18.4602 14.5172C18.379 14.0831 18.2745 13.6726 18.1494 13.2975C18.0201 12.9097 17.8443 12.5268 17.627 12.1599C17.4015 11.779 17.1366 11.4474 16.8394 11.1745C16.5286 10.889 16.148 10.6594 15.7079 10.492C15.2694 10.3255 14.7834 10.2411 14.2635 10.2411C14.0594 10.2411 13.8619 10.3215 13.4806 10.5598C13.2459 10.7067 12.9714 10.8767 12.665 11.0646C12.403 11.2249 12.0481 11.375 11.6097 11.5109C11.182 11.6438 10.7478 11.7112 10.3192 11.7112C9.89053 11.7112 9.45642 11.6438 9.02826 11.5109C8.59033 11.3752 8.23541 11.225 7.97372 11.0648C7.67023 10.8786 7.39557 10.7087 7.15738 10.5597C6.77652 10.3214 6.57892 10.2409 6.37476 10.2409C5.85474 10.2409 5.3689 10.3255 4.93051 10.4922C4.49075 10.6593 4.11005 10.8888 3.79892 11.1746C3.50183 11.4477 3.23679 11.7792 3.01157 12.1599C2.79443 12.5268 2.61865 12.9096 2.48926 13.2976C2.36429 13.6728 2.25977 14.0831 2.17859 14.5172C2.09818 14.9476 2.04355 15.3559 2.01654 15.7309C1.98999 16.0982 1.97656 16.4795 1.97656 16.8646C1.97656 17.8669 2.30844 18.6783 2.96289 19.2766C3.60925 19.8671 4.46451 20.1667 5.50455 20.1667H15.1347C16.1747 20.1667 17.0297 19.8673 17.6762 19.2766C18.3308 18.6787 18.6627 17.8672 18.6627 16.8645C18.6625 16.4776 18.6489 16.096 18.6222 15.7304Z",
    fill: "D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4064_2403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.2,
    fill: "D9D9D9",
    transform: "translate(0.335938 0.966602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.26fead5eed7aac4d1ade9ecaa03f6c47.svg";
export { ForwardRef as ReactComponent };